import { getLayerConfig } from '../scenarios.utils';

import './scenarios-legend.css';

function ScenariosLegend({ selectedLayer }) {
  const layerConfig = getLayerConfig(selectedLayer);
  if (!layerConfig) return null;

  return (
    <div className="scenarios-legend">
      <div className="scenarios-legend__title">{layerConfig.label}</div>
      <div className="scenarios-legend__items">
        {layerConfig.type === 'landuse'
          ? layerConfig.categories.map((cat) => (
              <div className="scenarios-legend__item" key={cat.code}>
                <span
                  className="scenarios-legend__swatch"
                  style={{ backgroundColor: cat.color }}
                />
                <span className="scenarios-legend__label">{cat.label}</span>
              </div>
            ))
          : layerConfig.stops.map((stop, index) => (
              <div className="scenarios-legend__item" key={index}>
                <span
                  className="scenarios-legend__swatch"
                  style={{ backgroundColor: stop.color }}
                />
                <span className="scenarios-legend__label">{stop.label}</span>
              </div>
            ))}
      </div>
    </div>
  );
}

export default ScenariosLegend;
